import LoginActionCreators from "@/Actions/Login";
import UsersActionCreators from "@/Actions/User";
import useDispatch from "@/Components/Utils/useDispatch";
import { ZomentumRoutes, ZomentumWindow } from "@/Contracts";
import { BillingStatusEnum } from "@/Contracts/Users";
import useAccountStatus from "@/Hooks/useAccountStatus";
import ZButton from "@atoms/ZButton";
import ZTypography from "@atoms/ZTypography";
import ZModal from "@atoms/ZModal";
import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

declare let window: ZomentumWindow;

const CancelledAccountModal: React.FC<RouteComponentProps> = props => {
	const auth0 = useAuth0();

	const dispatch = useDispatch();

	const cancelledAccount = useAccountStatus(BillingStatusEnum.Cancelled);

	const destroyThirdPartyScripts = () => {
		window.HubSpotConversations?.widget?.remove?.();
		if (process.env.REACT_APP_FRESHCHAT && window.fcWidget) {
			window.fcWidget.destroy();
		}
	};

	const handleLogoutUser = () => {
		destroyThirdPartyScripts();
		dispatch(LoginActionCreators.logout(auth0));
		dispatch(UsersActionCreators.resetUserState());
		props.history.push(ZomentumRoutes.Login);
	};

	return (
		<ZModal
			title="Account is deactivated"
			visible={cancelledAccount}
			footer={null}
			size="sm"
			closable={false}
		>
			<ZTypography.ZText className="block">
				This account is deactivated. Please contact{" "}
				<ZTypography.ZLink>
					{" "}
					<a href="mailto:support@zomentum.com">
						support@zomentum.com
					</a>{" "}
				</ZTypography.ZLink>
				for re-activating it.
			</ZTypography.ZText>
			<div className="mt-4 flex justify-end">
				<ZButton onClick={handleLogoutUser} type="primary">
					Logout
				</ZButton>
			</div>
		</ZModal>
	);
};

export default withRouter(CancelledAccountModal);
